export class DiagnosticReportSaveModel {
    type?: DiagnosticTypeEnum;
    content?: string | undefined;
}

export enum DiagnosticTypeEnum {
    None = 'none',
    Info = 'info',
    Warninig = 'warninig',
    Error = 'error',
    Unknown = 'unknown',
}
